// src/shell/GlobalStyles.jsx
// Injects global CSS once at the app root.
// Kept as a component so it hot-reloads with Vite.

export function GlobalStyles() {
  return (
    <style>{`
      *, *::before, *::after {
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
      }
      html, body {
        margin: 0;
        padding: 0;
        background: #1c1917;
        font-family: -apple-system, 'SF Pro Display', system-ui, sans-serif;
        overscroll-behavior: none;
      }
      ::-webkit-scrollbar { display: none; }
      * { scrollbar-width: none; }

      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50%       { opacity: 0.5; }
      }
      @keyframes blink {
        0%, 100% { opacity: 1; }
        50%       { opacity: 0; }
      }
      @keyframes slideUp {
        from { transform: translateY(100%); }
        to   { transform: translateY(0); }
      }
      @keyframes fadeIn {
        from { opacity: 0; }
        to   { opacity: 1; }
      }

      /* ── Accessibility overrides ── */
      .eos-large-text { zoom: 1.3; }

      /* High contrast via invert filter — works on inline styles */
      .eos-high-contrast #root { filter: invert(1) hue-rotate(180deg); }
      .eos-high-contrast img,
      .eos-high-contrast video { filter: invert(1) hue-rotate(180deg); }

      .eos-reduce-motion *,
      .eos-reduce-motion *::before,
      .eos-reduce-motion *::after {
        animation-duration: 0.01ms !important;
        transition-duration: 0.01ms !important;
      }
    `}</style>
  );
}
